import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteTaskBar } from "../data/taskbar/actions";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

const TaskBarContainer = (props) => {
	function buildTasks(props) {
		let self = this;
		let list = [];
		let history = props.history;
		for (let taskBarKey in props.list) {
			if (props.list.hasOwnProperty(taskBarKey)) {
				let component = props.list[taskBarKey];
				list.push(
					<component.type
						{...component.props}
						key={taskBarKey}
						history={history}
						remove={() => {
							props.deleteTaskBar(component.props.taskBarId);
						}}
					>
						{component.children}
					</component.type>
				);
			}
		}

		if (list.length > 0) {
			document.body.className += " bottomTaskBarActive";
		} else {
			let className = document.body.className;
			document.body.className = document.body.className.replace(
				/bottomTaskBarActive/g,
				""
			);
		}

		return list;
	}

	let list = buildTasks(props);

	if (list.length > 0) {
		return <div id="taskBarContainer">{list}</div>;
	} else {
		return null;
	}
};

export default withRouter(
	connect(
		(state) => {
			return {
				list: state.global.taskBar.list,
			};
		},
		(dispatch) =>
			bindActionCreators(
				{
					deleteTaskBar,
				},
				dispatch
			)
	)(TaskBarContainer)
);
